<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">邀请队友</span>
    </p>
    <div>
      <h-form label-position="left" :label-width="100">
        <h-form-item label="队伍名称：">
          <span>{{ inviteTeam.teamName }}</span>
        </h-form-item>
      </h-form>
      <h-form label-position="top">
        <h-form-item label="将邀请链接发送给小伙伴拉他进队吧：">
          <h-input v-model="inviteTeam.url" readonly></h-input>
        </h-form-item>
        <div class="check-warn">
          请确保将链接发送给确切想邀请的人，并提醒他不要传播
        </div>
      </h-form>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="doCopy">复制链接</comp-button>
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'

export default {
  name: 'InviteTeamMate',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    inviteTeam: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    // 复制
    doCopy() {
      let transfer = document.createElement('input')
      document.body.appendChild(transfer)
      // 这里表示想要复制的内容
      transfer.value = `快点这个链接加入我的 2022杭州市金融系统云技术职工技能大赛战队，${this.inviteTeam.url} 不要把这个链接转发给别人哦`
      transfer.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$hMessage.success('复制成功')
        this.showModal = false
      }
      document.body.removeChild(transfer)
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.check-warn {
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #ff3030;
  line-height: 22px;
  margin-bottom: 10px;
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamUp/InviteTeamMate.vue